import {
  buildErrorLogData,
  resolveCookieValues,
  type ErrorLogParams,
  type CookieValues,
} from "@/lib/logger/src/errorLogUtils";

type LogClientErrorWithContextParams = ErrorLogParams & {
  cookieHeader?: string;
  cookieValues?: CookieValues;
};

/**
 * Logs errors on the client side with full context information
 * Supports multiple cookie value sources with fallback priority:
 * 1. Explicitly provided cookie values
 * 2. Cookie values from window object
 * 3. Cookie values from server/header
 * 4. Cookie values from document.cookie (client-side fallback)
 */
export const logClientErrorWithContext = ({
  cookieHeader,
  cookieValues,
  ...params
}: LogClientErrorWithContextParams) => {
  // Resolve cookie values with priority order
  const windowCookieValues = typeof window !== 'undefined'
    ? (window as Window & { cookieValues?: CookieValues }).cookieValues
    : undefined;

  // If no explicit sources provided, try to extract from document.cookie
  const fallbackCookieHeader = !cookieHeader && !cookieValues && !windowCookieValues && typeof document !== 'undefined'
    ? document.cookie
    : cookieHeader;

  const resolvedCookieValues = resolveCookieValues({
    provided: cookieValues,
    windowValues: windowCookieValues,
    headerSource: fallbackCookieHeader,
  });

  const logData = buildErrorLogData(params, resolvedCookieValues);
  console.log(JSON.stringify(logData, null, 2));
};